import homologConfig from './homolog.config'

export default Object.assign(homologConfig, {
  environment: 'prod',
  applicationKey: 'cd323b3c-da73-4b18-8d66-688002cd9184',
  applicationSecret: 'jLYlcjYWZBWCAnCn6jiAblFd',
  sabBaseUrl: 'https://pkp-prod.sandboxkids.io',
  vindiBaseUrl: 'https://app.vindi.com.br',
  vindiApiSecret: '2o-JHJ2w6zasKfTUjjV839EyiK6pJWdvK-5Eu-ilu-g',
  appsBuilderBaseUrl: 'https://appsbuilder.sandboxkids.io',
  contentTreeBaseUrl: 'https://cdn.playkidsapp.com/playkids_web',
  peanutbutterBaseUrl: 'https://peanutbutter.playkids.com',
  brazeApiKey: 'a476e4d9-ed3a-4a8a-817e-8de8e6e2c62e',
  integrationACL: {
    baseUrl: 'https://playhub.sandboxkids.io',
    clientId: '',
    clientSecret: ''
  }
})
